export enum CustodianProfileRoutesEnum {
  Overview = 'overview',
  Assets = 'assets',
  Providers = 'providers',
  Operations = 'operations',
}
